(function () {
  const calcMinHeight = () => {
    const facetsTop = document.querySelector('.facets__top');
    const sortWrapper = document.querySelector('.facets__sort-wrapper');

    // Her iki element de varsa işlem yap
    if (facetsTop && sortWrapper) {
      try {
        const height = sortWrapper.getBoundingClientRect().height;
        facetsTop.style.minHeight = height + 'px';
      } catch (error) {
        console.warn('Min height hesaplanamadı:', error);
      }
    }
  }

  const resizeCollectionGrid = () => {
    const collectionGridSection = document.querySelector('.collection-grid-section') || document.querySelector('.section-search');

    // Section yoksa çık
    if (!collectionGridSection) return;

    const sectionResizeObserver = new ResizeObserver((entries) => {
      const [entry] = entries;
      // Entry ve target kontrolü
      if (entry && entry.target) {
        calcMinHeight();
      }
    });

    sectionResizeObserver.observe(collectionGridSection);
  }

  document.addEventListener('shopify:section:load', function () {
    resizeCollectionGrid();
  });

  resizeCollectionGrid();
})();